import {useEffect, useRef} from "react";

type Props = {
    setStatus: (status: boolean) => void,
    reset: () => void
}

export default () => {
    const pageRef = useRef<Props>(null)

    const noMore = () => {
        if (pageRef && pageRef.current) {
            pageRef.current.setStatus(false)
        }
    }

    const reset = () => {
        if (pageRef && pageRef.current) {
            pageRef.current.reset()
            pageRef.current.setStatus(true)
        }
    }

    return {pageRef, noMore, reset}
}
